import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  closeDrawer: {
    id: 'search.availability_drawer.close',
    description: 'Close drawer button',
    defaultMessage: 'Close'
  }
});
